import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { ComparisonItem, DeviceType } from '@models/comparisonItem';
import { getAllComparisonItemNames, getComparisonItemByNames } from '@services/deviceComparisonPublicService';

export const defaultDeviceComparisonKey = 'deviceComparison';

export function useComparisonNames(type: DeviceType): UseQueryResult<string[]> {
    return useQuery({
        queryKey: [defaultDeviceComparisonKey, type],
        queryFn: () => getAllComparisonItemNames(type),
    });
}

export function useComparisonItemByNames(type: DeviceType, names: string[]): UseQueryResult<ComparisonItem[]> {
    return useQuery({
        queryKey: [defaultDeviceComparisonKey, type, names],
        queryFn: () => getComparisonItemByNames(names, type),
        enabled: names.length > 0,
    });
}
